import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { dongBoApi } from "../../../api/dong-bo/dongBoApi";
import { IDongBoHocPhiRequest } from "../../../model/request/dong-bo/IDongBoHocPhiRequest";
import { IDongBoHocPhiSinhVien } from "../../../model/respone/dong-bo/IDongBoHocPhiSinhVien";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eDongBoHocPhiActionTypeIds,
  IDongBoHocPhiActionTypes,
} from "../../action-types/dong-bo/IDongBoHocPhiAction";
import { rootActions } from "../../actions/rootActions";
import { IProcessRequest } from "../../../model/request/IProcessRequest";
import {
  IHoanVeViRequest,
  IHoanVeViXemTruocRequest,
} from "../../../model/request/dong-bo/IHoanVeViRequest";
import {
  IHoanVeViKetQua,
  IHoanVeViKhoan,
} from "../../../model/respone/report/ISoDuSinhVienDashboard";

export function* dongBoHocPhiSaga(): any {
  yield takeLatest(eDongBoHocPhiActionTypeIds.LOAD_START, loadWorker);
  yield takeLatest(eDongBoHocPhiActionTypeIds.SYNC_START, syncWorker);
  yield takeLatest(eDongBoHocPhiActionTypeIds.HOAN_VE_VI_LOAD_START, hoanVeViLoadWorker);
  yield takeLatest(eDongBoHocPhiActionTypeIds.HOAN_VE_VI_START, hoanVeViWorker);
}

function* hoanVeViLoadWorker(action: IDongBoHocPhiActionTypes): any {
  const request = action.payload as IHoanVeViXemTruocRequest;
  const res: IBaseRespone = yield call(dongBoApi.XemTruocHoanVeVi, request);
  if (res.is_success) {
    yield put(
      rootActions.dongBo.hocPhi.HOAN_VE_VI_LOAD_SUCCESS(
        (res.data ?? []) as IHoanVeViKhoan[],
      ),
    );
  } else {
    yield put(
      rootActions.dongBo.hocPhi.HOAN_VE_VI_LOAD_ERR(
        res.message || "Chưa tải được danh sách khoản ví đã trả",
      ),
    );
  }
}

function* hoanVeViWorker(action: IDongBoHocPhiActionTypes): any {
  const request = action.payload as IProcessRequest<IHoanVeViRequest>;
  const res: IBaseRespone = yield call(dongBoApi.HoanVeVi, request);
  const loi: string[] = (res.data as IHoanVeViKetQua | undefined)?.loi ?? [];
  // Kèm vài lý do không hoàn được để cán bộ biết mà xem lại (danh sách đầy đủ nằm trong nhật ký).
  const chiTietLoi = loi.length
    ? ` ${loi.slice(0, 3).join("; ")}${loi.length > 3 ? "; …" : ""}`
    : "";
  if (res.is_success) {
    yield put(
      rootActions.dongBo.hocPhi.HOAN_VE_VI_SUCCESS(
        (res.message || "Đã hoàn về ví.") + chiTietLoi,
      ),
    );
  } else {
    yield put(
      rootActions.dongBo.hocPhi.HOAN_VE_VI_ERR(
        res.message || "Chưa hoàn về ví được, vui lòng thử lại.",
      ),
    );
  }
}

function* loadWorker(action: IDongBoHocPhiActionTypes): any {
  const request = action.payload as IDongBoHocPhiRequest;
  const res: IBaseRespone = yield call(dongBoApi.SelectHocPhi, request);
  if (res.is_success) {
    var data = res.data as IDongBoHocPhiSinhVien[];
    yield put(rootActions.dongBo.hocPhi.LOAD_SUCCESS(data));
  } else {
    yield put(rootActions.dongBo.hocPhi.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* syncWorker(action: IDongBoHocPhiActionTypes): any {
  const request = action.payload as IProcessRequest<IDongBoHocPhiRequest>;
  const res: IBaseRespone = yield call(dongBoApi.SyncHocPhi, request);
  if (res.is_success) {
    var data = res.data as IDongBoHocPhiSinhVien[];
    yield put(rootActions.dongBo.hocPhi.SYNC_SUCCESS(data));
  } else {
    yield put(rootActions.dongBo.hocPhi.SYNC_ERR(res.message ?? "Có lỗi"));
  }
}
